import {createActionGroup, emptyProps} from '@ngrx/store';
import {BorrowingHistoryRecord, Checkout, CheckoutClaim, CHECKOUTS_FEATURE_KEY, FileClaimValue} from '@store/checkouts/checkouts.types';
import {DateOnlyIsoString, ListData} from '@aviary/store/common/common.types';

export const CheckoutsActions = createActionGroup({
  source: CHECKOUTS_FEATURE_KEY,
  events: {
    'Load Checked Out': emptyProps(),
    'Load Checked Out Success': (listData: ListData<Checkout>) => ({listData}),
    'Load Checked Out Failure': (error: unknown) => ({error}),

    'Load Next Checked Out Due Date': emptyProps(),
    'Load Next Checked Out Due Date Success': (date?: DateOnlyIsoString) => ({date}),
    'Load Next Checked Out Due Date Failure': (error: unknown) => ({error}),

    'Load Checkout Claims': emptyProps(),
    'Load Checkout Claims Success': (listData: ListData<CheckoutClaim>) => ({listData}),
    'Load Checkout Claims Failure': (error: unknown) => ({error}),

    'Load Borrowing History': emptyProps(),
    'Load Borrowing History Success': (listData: ListData<BorrowingHistoryRecord>) => ({listData}),
    'Load Borrowing History Failure': (error: unknown) => ({error}),
    'Load Recent Borrowing History': emptyProps(),
    'Load Recent Borrowing History Success': (listData: ListData<BorrowingHistoryRecord>) => ({listData}),
    'Load Recent Borrowing History Failure': (error: unknown) => ({error}),

    'Show Renew Item': (checkout: Checkout) => ({checkout}),
    'Renew Item': (checkout: Checkout) => ({checkout}),
    'Renew Item Success': emptyProps(),
    'Renew Item Failure': (error: unknown) => ({error}),

    'Show Renew All Items': emptyProps(),
    'Renew All Items': emptyProps(),
    'Renew All Items Success': emptyProps(),
    'Renew All Items Failure': (error: unknown) => ({error}),
    'Show Some Items Not Renewed': (renewedCount: number) => ({renewedCount}),

    'Show File Claim': (checkout: Checkout) => ({checkout}),
    'File Claim': (checkout: Checkout, value: FileClaimValue) => ({checkout, value}),
    'File Claim Success': emptyProps(),
    'File Claim Failure': (error: unknown) => ({error}),

    'Show View Claim': (checkoutClaim: CheckoutClaim) => ({checkoutClaim}),

  },
});
